<template lang="html">
  <div class="quanyi">
    <common-header></common-header>
    <list-kv :kvArray="items"></list-kv>
    <quanyi-container></quanyi-container>
    <common-footer></common-footer>
  </div>
</template>

<script>
	//组件
	import commonHeader from '../../components/common/commonHeader'
	import commonFooter from '../../components/common/commonFooter'
	import listKv from '../../components/common/listKv'
	import quanyiContainer from '../../components/quanyi/quanyiContainer'
	//接口
	import Server from '../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  		quanyiContainer
	  	},
	  	created(){
	  		Server.listConfig('membershipBanner').then((result)=>{
	  			if(result.code == '0'){
	  				this.items = result.msg.types;
	  				console.log(this.items);
	  			}
	  		})
	  	},
	}
</script>

<style lang="less" scoped>
	.quanyi{
		// padding-bottom:250px;
	}
</style>


// WEBPACK FOOTER //
// src/container/quanyiPage/quanyi.vue